export enum NotificationHeader {
  deleteConfirmation = 'Confirm Delete',
  disposedConfirmation = 'Confirm re-Activate Disposed',
  archiveConfirmation = 'Confirm Inactive',
  restoreConfirmation = 'Confirm Active',
  copyConfirmation = 'Confirm Copy',
  success = 'Success!',
  error = 'Error!',
  clearAllLinesHeaderText = 'Clear',
  navigateMeToGmail = 'Navigate me to gmail',
  navigateMeToOutlook = 'Navigate me to outlook',
  deleteYourAccount = 'Delete your account',
  reauthenticateYourAccount = 'Reauthenticate Your Account',
  confirmation = 'Confirmation',
  trialBalanceReferesh = 'Once refreshed, the changes cannot be reverted back.',
  redirect = 'Redirect me !'
}

export enum NotificationDetails {
  archiveDetailText = 'Are you sure you want to inactivate the data?',
  restoreDetailText = 'Are you sure you want to activate the data?',
  deleteAllDetailText = 'Please confirm you want to delete these items. Deleting cannot be undone.',
  disposedDetailText = 'Are you sure you want to re-activate the disposed asset?',
  navigateMeToGmailText = 'Are you sure you want to navigate to your Gmail account?',
  navigateMeToOutlookText = 'Are you sure you want to navigate to your Outlook account?',
  deleteYourAccountText = 'Are you sure you want to delete your account?',
  mergeTrailBalanceText = 'Are you sure you want to merge the values in the same account?',
  trialBalanceErrorText = 'The following accounts have no values and cannot be imported into the <b>Trial Balance</b>.',
  deleteRow = 'Are you sure you want to delete this row?',
  copyDetail = 'Are you sure you want to copy data from the previous year?',
  trialBalanceReferesh = 'Are you sure you want to refresh this Trial Balance?',
  Submit = 'Are you sure you want to submit these details?',
  regenerateDetailText = `Are you sure to regenerate the accounts? </br>
    Accounts figures can be changed, if you have updated the trial balance. </br>
    This accounts will be regenerated with the current settings.`,
  clientDelete  = 'Sure, you want to delete the charity',
  fundExplainCheckDetailText = `Please ensure all income and expense accounts are assigned to the correct funds before generating the report. </br></br>
    Go to <b>Trial Balance → Edit</b> page and update the fund assignments as required. </br></br>
    Click <b>Yes</b> to proceed anyway.`,
  fixedAssetsWarning = 'One or more Fixed Assets are associated with this transaction.<br>Updating this transaction will reset the Fixed Assets completely and the assets shall be explained again.',
}

export enum NotificationAddClosePopUpMessage {
  defaultHeaderText = 'Terminate process',
  defaultBodyText = 'Sure, you want to terminate the process.',
  defaultAnnualReportHeaderText = 'Confirmation',
  defaultAnnualReportBodyText = 'Do you want to save the report?',
  saveOpeningBalanceHeaderText = 'Confirmation',
  informHeaderText = 'Information',
  saveOpeningBalanceBodyText = 'This Opening Balance will be saved as draft because debit and credit amounts are not equal.',
  saveOpeningBalanceBodyTextTB = 'This Trial Balance will be saved as draft because debit and credit amounts are not equal.',
  saveJournalBodyText = 'This journal will be saved as a draft because debit and credit amounts are not equal. Balance the journal for accurate final accounts.',
  saveJournalBodyTextTB = 'This Trial Balance will be saved as a draft because debit and credit amounts are not equal. Balance the journal for accurate final accounts.',
  informBodyText = 'All explained values will be marked as a draft.',
  importBodyText = 'Sure, you want to ignore and continue.',
  saveWarningBodyText = 'Are you sure you want to navigate without saving changes?',
}
//Note: Please do not add any new enum values in the middle of the existing enum values. Add new enum values at the end of the existing enum values.
export enum NotificationTextMessage {
  qtyErrorMessage = 'Quantity should be greater than 0.',
  amtErrorMessage = 'Amount should be greater than 0.',
  validPeriodDateMessage = 'Date should be between accounting period.',
  lockedAccoutingPeriodDateMessage = 'Accounting period is locked.',
  successMessage = 'The operation completed successfully.',
  emailMessage = 'Email sent successfully.',
  emailFailedMessage = 'Unable to send email. Please try again later.',
  errorMessage = 'An unexpected error occurred. Please refresh or contact support.',
  invalidAmount = "Amount is invalid",
  errorWrongMessage = 'An unexpected error occurred. Please refresh or contact support.',
  bankAccountAlreadyExits = 'Bank account already exits!',
  recordCopySuccessfully = 'Record copied successfully',
  recordArchivedSuccessfully = 'Record inactivated successfully',
  recordRestoredSuccessfully = 'Record activated successfully',
  recordDeletedSuccessfully = 'Record deleted successfully',
  recordActivateSuccessfully = 'Record re-Activate successfully',
  noRecordFoundText = 'No record found.',
  amountErrorMessage = 'Entered Amount Exceed Limit',
  fileSizeExceeds = 'File should be less than 10 MB.',
  filenameWithSpecialCharacter = 'File name should not contain special characters.',
  fileUploaded = 'File uploaded successfully.',
  capiumSaveMessage = 'VAT return submitted to Capium successfully.',
  vatTransactionImported = 'Vat transaction imported successfully',
  exceedDateMessage = 'End Date should not be more than one year',
  clearAllLinesBodyText = 'Sure, you want to clear all the lines.',
  explainOpeningBalance = 'Amount cannot be greater than total opening balance',
  mailDeleteSucessfully = 'Mail deleted successfully.',
  moveToSuccessList = 'Record move to success list',
  invoiceNoIsExist = 'Invoice number is exists',
  billNoIsExist = 'Bill number is exists',
  creditNoteNoIsExist = 'Credit Note number is exists',
  debitNoteNoIsExist = 'Debit Note number is exists',
  fixedAssetNoIsExist = 'Fixed Asset number is exists',
  defaultIsExist = 'This Field value is already exists',
  accountCodeExist = 'The account code you entered already exists. Please choose a different account code to proceed.',
  succesList = 'No records are updated',
  mailSentSuccessfully = 'Mail sent successfully.',
  duplicateMail = 'To, CC, or BCC email addresses must be unique.',
  invoiceNoValidateSuccessfully = 'Invoice number validated successfully',
  blankLineError = 'Please remove the blank line to save the data',
  noDataToExport = 'Sorry, There is no data to export.',
  checkAmountErrorMessage = 'Amount has to be greater than 0 to generate a Receipt.',
  checkAdvancePaymentErrorMessage = 'Entered total advance payment amount should be greater then Receipt.',
  transferErrorMessage = 'Sorry, cannot be transferred to the same account',
  noSelectedErrorMessage = 'Please select atleast one checkbox to depriciate assets!',
  dataInLockedPeriod = 'Sorry, Accounting period is locked for the selected date.',
  noSelectedBankErrorMessage = 'Please select atleast one checkbox to save changes.',
  accountErrorMessage = 'Please select account to save changes.',
  fileExtensionValidatonForImage = 'File must be .png, .jpg, or .jpeg.',
  fileExtensionValidatonForPDF = 'File must be .pdf.',
  pleaseAddSignature = 'Please add signature.',
  errorDebitCreditMessage = 'Debit amount and credit amount should be same to save changes.',
  amountTotalError = 'Entered total amount should be greater then import bank payment',
  receiptSelectError = 'No invoice available for receipt generation.',
  submittedToHMRC = 'Successfully submitted to HMRC.',
  netAmountDigitErrorMessage = 'Net Amount should not be than 14 digit before decimal dot',
  vatAmountDigitErrorMessage = 'Vat Amount should not be than 14 digit before decimal dot',
  amountDigitErrorMessage = 'Amount should not be than 14 digit before decimal dot',
  emptyBody = 'Empty email body is not allowed!',
  trailBalanceZeroValueValidation = 'Sorry you cannot merge this account as the amount gets zero after merging.',
  donorIsExist = 'Donor already exists',
  checkVatNumber = 'Please check your VAT Details.',
  invoiceReceiptAllocationMissing = 'Receipt is required for saving the invoice',
  invoiceAndReceiptAmountAllocationMissMatch = 'Receipt amount does not match the invoice amount',
  allocateFullReceipt = 'Please allocate full amount to save',
  fileSize5mb = 'File should be less than 5 MB',
  fileSize2mb = 'File should be less than 2 MB',
  fileJpgPng = 'File should be .png or .jpg extension',
  fileFormatNotSupported = 'File format not supported',
  validationMessage = 'Please fill all the mandatory fields.',
  canNotEdit = 'This record can not be edited!',
  ViewOnlyAccessMessage = 'You have view-only access for this section.',
  NoImportAccesssMessage = 'You do not have access to import in this module.',
  NoRecordsFound = 'No records found',
  NoRecordsFoundForFilter = 'No records found for the given search/filter values',
  permissionChangeAndNotSave = 'Please save your permission changes to edit user permissions.',
  canNotDelete = 'You do not have permission to delete selected records.',
  canNotInactive = 'You do not have permission to inactive selected records',
  alreadyInactive = 'The selected record is already inactive.',
  alreadyRestore = 'Selected record has already active record',
  trialBalanceRefereshSuccessfully = 'Trial Balance has been imported and saved successfully.',
  totalIncomeErrorMessage = 'Total Income is not matching.',
  totalReceiptsErrorMessage = 'Total Receipts is not matching.',
  totalExpenseErrorMessage = 'Total Expense is not matching.',
  totalPaymentsErrorMessage = 'Total Payments is not matching.',
  totalOpeningErrorMessage = 'Total Opening is not matching',
  totalGainLossErrorMessage = 'Total Gain/Loss is not matching.',
  totalFundTransferErrorMessage = 'Fund Transfer In must equal Fund Transfer Out.',
  vatNumberErrorMessage = 'Please enter a valid VAT registration number.',
  auditIdErrorMessage = 'Need to select audit to update',
  sumissionDelete = 'Report cannot be deleted as it has associated submissions',
  invalidDateSelection='Invalid date selection',
  contactNameIsExist = 'Contact Name already exists',
  emailIsExist = 'Email already exists',
  firstNameIsExist = 'First Name already exists',
  reportRegeneratedSuccessfully ='Report Regenerated Successfully',
  fillRequiredFields = 'Please fill all required fields correctly!', 
  moreThan18months = 'Accounting Period can\'t be more than 18 months.',
  accountingPeriodLocked = 'The selected accounting period is locked',
  startDateCanNotBeEarlier = "Start Date cannot be earlier or equal than the previous row's End Date.",
  startDateMustBeOneDayAfterPreviousEndDate = "Start Date must be one day after previous End Date.",
  startDateCannotBeBeforeEstablishDate = 'Start Date cannot be before Date Of Commencement.',
  unlockCurrentBeforePrevious = 'Please unlock the current period first before unlocking any previous periods.',
  noUnlockedPeriodAvailable = 'Accounting period(s) locked. Unlock to preview the report.',
  charityProfileUpdatedSuccessfully = 'Charity profile updated successfully.',
  charityProfileCreatedSuccessfully = 'Charity profile created successfully.',
  bulkeditErrormMsg="Please select Account or Fund.",
  hmrcSubmitMessage = 'VAT return submitted to HMRC successfully.',
  depreciableAssetRequiredMsg = 'Please Check Depreciable Asset Checkbox to enter Depreciation details.',
  emailRecipientLimitExceeded = 'Maximum 10 email recipients are allowed.',
  NoDataToSave = 'No data to save.',
  deleteCompany = 'Company Deleted Successfully.',
  explainBeforeDepreciation = 'You will need to explain at least one asset before running Depreciation.',
}
